"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const iso_locales_db_1 = require("./iso-locales-db");
function find(predicate, thisArg) {
    const all = iso_locales_db_1.getLocales();
    return all.find(predicate, thisArg);
}
exports.find = find;
function findByLanguage(text) {
    return find(isoLocale => isoLocale.language === text);
}
exports.findByLanguage = findByLanguage;
function findByLanguageLocal(text) {
    return find(isoLocale => isoLocale.language_local === text);
}
exports.findByLanguageLocal = findByLanguageLocal;
function findByRegion(text) {
    return find(isoLocale => isoLocale.region === text);
}
exports.findByRegion = findByRegion;
function findByScript(text) {
    return find(isoLocale => isoLocale.script === text);
}
exports.findByScript = findByScript;
function findByTag(text, options) {
    if (options && (options.ignorecase === false)) {
        return find(isoLocale => isoLocale.tag === text);
    }
    else {
        text = text.toLowerCase();
        return find(isoLocale => isoLocale.tag.toLowerCase() === text);
    }
}
exports.findByTag = findByTag;
function findByLCID(lcid) {
    return find(isoLocale => isoLocale.lcid === lcid);
}
exports.findByLCID = findByLCID;
//# sourceMappingURL=iso-locales-find.js.map